import React from 'react';
import type { FC } from 'react';
import { Box, Text } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';

export const LoginRequiredWarning: FC = () => {
  const { t } = useTranslation();

  return (
    <Box flexDirection="column" marginBottom={1}>
      <Text>{t('create_app.login_required_warning')}</Text>
    </Box>
  );
};
